import * as Eff from 'redux-saga/effects';
import { EXPORT_FILE } from '../components/header/header-actions';
import { exportFileStartWorker } from '../components/header/header-sagas';
import { FETCH_AUDIT } from '../components/audit/audit-actions';
import { fetchAuditStartWorker } from '../components/audit/audit-sagas';
import {
  ASSIGN_TEMPLATE,
  ASSIGN_TEMPLATE_SPECIAL,
  BULK_ASSIGN_ACTIVITY,
  BULK_ASSIGN_TEMPLATE,
  BULK_ASSIGN_TEMPLATE_SPECIAL,
  FETCH_ACTIVITIES,
  FETCH_ALL_TEMPLATES,
  FETCH_DISTRICTS,
  FETCH_DOCTOR_AVAILABILITY,
  FETCH_DOCTORS,
  FETCH_DOCTORS_HOO_CHANGED,
  FETCH_DOCTORS_SPECIAL,
  FETCH_DOCTORS_LIVE,
  FETCH_OD_DATA_INCOMPLETE,
  FETCH_REGIONS,
  FETCH_SELECTED_DOCTOR,
  FETCH_SELECTED_DOCTOR_SPECIAL,
  FETCH_SELECTED_DOCTORS_SPECIAL,
  FETCH_SELECTED_DOCTORS_SPECIAL_ALL,
  FETCH_TEMPLATES,
} from '../pace/pace-actions';
import {
  assignTemplateStartWorker,
  fetchDoctorsSpecialStartWorker,
  fetchDoctorsLiveStartWorker,
  fetchDoctorsStartWorker,
  fetchSelectedDoctorStartWorker,
  fetchTemplatesStartWorker,
  fetchAllTemplatesStartWorker,
  fetchODDataIncompleteStartWorker,
  fetchSelectedDoctorSpecialStartWorker,
  assignTemplateSpecialStartWorker,
  fetchDoctorAvailabilityStartWorker,
  bulkAssignTemplateSpecialWorker,
  bulkAssignTemplateStartWorker,
  fetchRegionsStartWorker,
  fetchDistrictsStartWorker,
  fetchSelectedDoctorsSpecialStartWorker,
  fetchSelectedDoctorsSpecialAllStartWorker,
  bulkAssignActivityStartWorker,
  fetchActivitiesStartWorker,
  fetchDoctorsHooChangedStartWorker,
} from '../pace/pace-sagas';
import {
  CLONE_TEMPLATE_DETAILS,
  FETCH_TEMPLATE_DETAILS,
  FETCH_LIVERANGETEMPLATE_DETAILS,
  IMPORT_FILE,
  REMOVE_TEMPLATES,
  REMOVE_TEMPLATEDRAFTS,
  RENAME_TEMPLATE,
  SEARCH_TEMPLATES,
  SEARCH_TEMPLATEDRAFTS,
  UNMAP_OFFICE,
  UPDATE_VALIDATED_IMPORT,
  FETCH_EXAM_TYPES,
  UPDATE_LIVE_RANGE0_TEMPLATE_SLOT_DETAILS,
  UPDATE_LIVE_SPECIALRANGE_TEMPLATE_SLOT_DETAILS,
  UPDATE_TEMPLATE_SLOT_DETAILS,
  UPDATE_TEMPLATEDRAFT_SLOT_DETAILS,
  CHECK_TEMPLATE_NAME,
  CREATE_TEMPLATE_DETAILS,
  CREATE_TEMPLATEDRAFT_DETAILS,
  FETCH_TEMPLATEDRAFT_DETAILS,
  PUBLISH_DRAFT,
  BULK_CLONE_TEMPLATES,
} from '../components/templates/templates-actions';
import {
  fetchTemplateDetailsStartWorker,
  removeTemplateStartWorker,
  searchTemplatesStartWorker,
  renameTemplateNameStartWorker,
  importBulkUpdateFileStartWorker,
  updateValidatedImportStartWorker,
  unmapingOffice,
  setExamTypesStartWorker,
  cloneTemplateDetailsStartWorker,
  updateTemplateDetailsStartWorker,
  checkTemplateNameWorker,
  createTemplateDetailsStartWorker,
  createTemplateDraftDetailsStartWorker,
  searchTemplateDraftsStartWorker,
  fetchTemplateDraftDetailsStartWorker,
  fetchLiveRangeTemplateDetailsStartWorker,
  removeTemplateDraftsStartWorker,
  updateTemplateDraftDetailsStartWorker,
  publishDraftStartWorker,
  bulkCloneTemplatesStartWorker,
  updateLiveSpecialRangeTemplateDetailsStartWorker,
  updateLiveRange0TemplateDetailsStartWorker,
} from '../components/templates/templates-sagas';
import { fetchNewOfficesStartWorker } from '../pace/new-offices/new-offices-sagas';
import { FETCH_NEW_OFFICES } from '../pace/new-offices/new-offices-actions';
import { exportReportStartWorker } from '../components/reports/reports-sagas';
import { EXPORT_REPORT } from '../components/reports/reports-actions';
import { FETCH_PATTERNS, FETCH_RAMP_SETTINGS, UPDATE_RAMP_SETTINGS } from './common/common-actions';
import {
  fetchPatternsStartWorker,
  fetchRampSettingsStartWorker,
  updateRampSettingsStartWorker,
} from './common/common-sagas';
import {
  FETCH_RAMPS,
  FETCH_ASSIGNMENTS,
  SAVE_RAMP,
  SAVE_ASSIGNMENT,
  APPLY_ASSIGNMENT,
  DELETE_ASSIGNMENT,
} from '../components/schedule-ramps/ramps-actions';
import {
  fetchRampsStartWorker,
  fetchAssignmentsStartWorker,
  saveRampStartWorker,
  saveAssignmentStartWorker,
  applyAssignmentStartWorker,
  deleteAssignmentStartWorker,
} from '../components/schedule-ramps/ramps-sagas';
import {
  CREATE_EXCEPTION,
  FETCH_EMPLOYEES,
  FETCH_EXCEPTION_DETAILS,
  FETCH_OFFICES,
  FETCH_OFFICES_SUCCESS,
  SEARCH_EXCEPTION,
} from '../components/ExceptiopnManagement/actions';
import {
  createExceptionStartWorker,
  fetchEmployeesStartWorker,
  fetchExceptionDetailsStartWorker,
  fetchOfficesStartWorker,
  searchExceptionStartWorker,
} from '../components/ExceptiopnManagement/sagas';
import {
  getResourcesStartWorker,
  validateFileStartWorker,
  processCleanupStartWorker,
  resourceFileDetailsStartWorker,
  downloadFileStartWorker,
  deleteResourceStartWorker,
} from '../components/ResourceCleanup/resources-sagas';
import {
  FETCH_RESOURCE_CLEANUP_DETAILS,
  VALIDATE_FILE,
  PROCESS_CLEANUP,
  FETCH_RESOURCE_FILE_DETAILS,
  DOWNLOAD_FILE,
  DELETE_FILE,
} from '../components/ResourceCleanup/resources-action';
import {
  SEARCH_TEMPLATE,
  FETCH_LOCATIONS,
  FETCH_ODs,
  SAVE_TEMPLATE_ACCOMMODATION,
  FETCH_TEMPLATE_PATTERNS,
  FETCH_CURRENT_TEMPLATE_PATTERNS,
  FETCH_RCD_LOCATION_NUMBER,
  FETCH_CHANGE_RESULTS,
  DELETE_TEMPLATE_ACCOMMODATION,
} from '../components/TemplatesAccommodations/actions';
import {
  fetchLocations,
  fetchODs,
  fetchTemplatePatterns,
  fetchCurrentTemplatePatterns,
  saveTemplateAccomodation,
  searchTemplateStartWorker,
  fetchRCDByLocationNumber,
  fetchChangeResults,
  deleteTemplateAccomodation,
} from '../components/TemplatesAccommodations/sagas';
import { FETCH_USER_POSITIONS } from './user/user-actions';
import { fetchUserPositionsStartWorker } from './user/user-sagas';

const takeEvery: any = Eff.takeEvery;

export default function* rootSaga() {
  yield takeEvery(FETCH_AUDIT, fetchAuditStartWorker);
  yield takeEvery(EXPORT_FILE, exportFileStartWorker);
  yield takeEvery(FETCH_DOCTORS, fetchDoctorsStartWorker);
  yield takeEvery(FETCH_DOCTORS_SPECIAL, fetchDoctorsSpecialStartWorker);
  yield takeEvery(FETCH_DOCTORS_LIVE, fetchDoctorsLiveStartWorker);
  yield takeEvery(FETCH_OD_DATA_INCOMPLETE, fetchODDataIncompleteStartWorker);
  yield takeEvery(FETCH_SELECTED_DOCTOR, fetchSelectedDoctorStartWorker);
  yield takeEvery(FETCH_SELECTED_DOCTOR_SPECIAL, fetchSelectedDoctorSpecialStartWorker);
  yield takeEvery(FETCH_SELECTED_DOCTORS_SPECIAL, fetchSelectedDoctorsSpecialStartWorker);
  yield takeEvery(FETCH_SELECTED_DOCTORS_SPECIAL_ALL, fetchSelectedDoctorsSpecialAllStartWorker);
  yield takeEvery(FETCH_TEMPLATES, fetchTemplatesStartWorker);
  yield takeEvery(FETCH_ALL_TEMPLATES, fetchAllTemplatesStartWorker);
  yield takeEvery(ASSIGN_TEMPLATE, assignTemplateStartWorker);
  yield takeEvery(ASSIGN_TEMPLATE_SPECIAL, assignTemplateSpecialStartWorker);
  yield takeEvery(FETCH_DOCTOR_AVAILABILITY, fetchDoctorAvailabilityStartWorker);
  yield takeEvery(BULK_ASSIGN_TEMPLATE_SPECIAL, bulkAssignTemplateSpecialWorker);
  yield takeEvery(BULK_ASSIGN_TEMPLATE, bulkAssignTemplateStartWorker);
  yield takeEvery(FETCH_REGIONS, fetchRegionsStartWorker);
  yield takeEvery(FETCH_DISTRICTS, fetchDistrictsStartWorker);
  yield takeEvery(SEARCH_TEMPLATES, searchTemplatesStartWorker);
  yield takeEvery(FETCH_TEMPLATE_DETAILS, fetchTemplateDetailsStartWorker);
  yield takeEvery(FETCH_LIVERANGETEMPLATE_DETAILS, fetchLiveRangeTemplateDetailsStartWorker);
  yield takeEvery(REMOVE_TEMPLATES, removeTemplateStartWorker);
  yield takeEvery(FETCH_NEW_OFFICES, fetchNewOfficesStartWorker);
  yield takeEvery(RENAME_TEMPLATE, renameTemplateNameStartWorker);
  yield takeEvery(EXPORT_REPORT, exportReportStartWorker);
  yield takeEvery(FETCH_RAMP_SETTINGS, fetchRampSettingsStartWorker);
  yield takeEvery(UPDATE_RAMP_SETTINGS, updateRampSettingsStartWorker);
  yield takeEvery(FETCH_RAMPS, fetchRampsStartWorker);
  yield takeEvery(FETCH_ASSIGNMENTS, fetchAssignmentsStartWorker);
  yield takeEvery(SAVE_RAMP, saveRampStartWorker);
  yield takeEvery(SAVE_ASSIGNMENT, saveAssignmentStartWorker);
  yield takeEvery(APPLY_ASSIGNMENT, applyAssignmentStartWorker);
  yield takeEvery(DELETE_ASSIGNMENT, deleteAssignmentStartWorker);
  yield takeEvery(FETCH_PATTERNS, fetchPatternsStartWorker);
  yield takeEvery(FETCH_ACTIVITIES, fetchActivitiesStartWorker);
  yield takeEvery(BULK_ASSIGN_ACTIVITY, bulkAssignActivityStartWorker);
  yield takeEvery(FETCH_DOCTORS_HOO_CHANGED, fetchDoctorsHooChangedStartWorker);
  yield takeEvery(IMPORT_FILE, importBulkUpdateFileStartWorker);
  yield takeEvery(UPDATE_VALIDATED_IMPORT, updateValidatedImportStartWorker);
  yield takeEvery(SEARCH_EXCEPTION, searchExceptionStartWorker);
  yield takeEvery(FETCH_EXCEPTION_DETAILS, fetchExceptionDetailsStartWorker);
  yield takeEvery(CREATE_EXCEPTION, createExceptionStartWorker);
  yield takeEvery(FETCH_OFFICES, fetchOfficesStartWorker);
  yield takeEvery(FETCH_EMPLOYEES, fetchEmployeesStartWorker);
  yield takeEvery(UNMAP_OFFICE, unmapingOffice);
  yield takeEvery(FETCH_RESOURCE_CLEANUP_DETAILS, getResourcesStartWorker);
  yield takeEvery(VALIDATE_FILE, validateFileStartWorker);
  yield takeEvery(PROCESS_CLEANUP, processCleanupStartWorker);
  yield takeEvery(FETCH_RESOURCE_FILE_DETAILS, resourceFileDetailsStartWorker);
  yield takeEvery(DOWNLOAD_FILE, downloadFileStartWorker);
  yield takeEvery(DELETE_FILE, deleteResourceStartWorker);
  yield takeEvery(SEARCH_TEMPLATE, searchTemplateStartWorker);
  yield takeEvery(FETCH_LOCATIONS, fetchLocations);
  yield takeEvery(FETCH_USER_POSITIONS, fetchUserPositionsStartWorker);
  yield takeEvery(FETCH_ODs, fetchODs);
  yield takeEvery(SAVE_TEMPLATE_ACCOMMODATION, saveTemplateAccomodation);
  yield takeEvery(DELETE_TEMPLATE_ACCOMMODATION, deleteTemplateAccomodation);
  yield takeEvery(FETCH_TEMPLATE_PATTERNS, fetchTemplatePatterns);
  yield takeEvery(FETCH_CURRENT_TEMPLATE_PATTERNS, fetchCurrentTemplatePatterns);
  yield takeEvery(FETCH_RCD_LOCATION_NUMBER, fetchRCDByLocationNumber);
  yield takeEvery(FETCH_CHANGE_RESULTS, fetchChangeResults);
  yield takeEvery(FETCH_EXAM_TYPES, setExamTypesStartWorker);
  yield takeEvery(CLONE_TEMPLATE_DETAILS, cloneTemplateDetailsStartWorker);
  yield takeEvery(UPDATE_TEMPLATE_SLOT_DETAILS, updateTemplateDetailsStartWorker);
  yield takeEvery(CREATE_TEMPLATE_DETAILS, createTemplateDetailsStartWorker);
  yield takeEvery(CREATE_TEMPLATEDRAFT_DETAILS, createTemplateDraftDetailsStartWorker);
  yield takeEvery(CHECK_TEMPLATE_NAME, checkTemplateNameWorker);
  yield takeEvery(SEARCH_TEMPLATEDRAFTS, searchTemplateDraftsStartWorker);
  yield takeEvery(FETCH_TEMPLATEDRAFT_DETAILS, fetchTemplateDraftDetailsStartWorker);
  yield takeEvery(REMOVE_TEMPLATEDRAFTS, removeTemplateDraftsStartWorker);
  yield takeEvery(UPDATE_TEMPLATEDRAFT_SLOT_DETAILS, updateTemplateDraftDetailsStartWorker);
  yield takeEvery(BULK_CLONE_TEMPLATES, bulkCloneTemplatesStartWorker);
  yield takeEvery(PUBLISH_DRAFT, publishDraftStartWorker);
  yield takeEvery(UPDATE_LIVE_SPECIALRANGE_TEMPLATE_SLOT_DETAILS, updateLiveSpecialRangeTemplateDetailsStartWorker);
  yield takeEvery(UPDATE_LIVE_RANGE0_TEMPLATE_SLOT_DETAILS, updateLiveRange0TemplateDetailsStartWorker);
}
